import styled from '@emotion/styled/macro';
import { StyledInputProps } from '../../../components/Input/Input.types';
import rem from '../../../utils/rem/rem';

export const ComparePage = styled.div`
  padding: 0 ${rem(32)} ${rem(32)} ${rem(32)};
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const InputButtonWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-bottom: ${rem(2)};

  input {
    width: ${rem(108)};
  }

  button {
    margin-bottom: ${rem(6)};
  }
`;

export const InputWrapper = styled.div<StyledInputProps>`
  display: flex;
  align-items: ${({ errorText }) => (errorText !== '' ? 'flex-start' : 'flex-end')};
  gap: ${rem(30)};

  button {
    margin-top: ${({ errorText }) => (errorText !== '' ? rem(24) : rem(0))};
  }
`;